import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import styles from './GoogleLoginButton.module.css';
import { API_BASE_URL as API_URL } from '../../config/apiBase';

const GoogleLoginButton = ({ onSuccess, onError, className = '' }) => {
  const { login } = useAuth();
  const { showSuccess, showError } = useToast();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      // Send the ID token to our backend
      const response = await fetch(`${API_URL}/auth/google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idToken: credentialResponse.credential,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle deactivated account specifically
        if (response.status === 403 && data.message && data.message.includes('deactivated')) {
          throw new Error(data.message);
        }
        throw new Error(data.message || 'Google authentication failed');
      }

      if (data.success) {
        // Store the JWT token
        localStorage.setItem('token', data.data.token);
        
        // Update auth context
        await login(null, null, null, data.data.token, data.data.user);
        
        // showSuccess('Google login successful!');
        
        if (onSuccess) {
          onSuccess(data.data);
        }
      } else {
        throw new Error(data.message || 'Google authentication failed');
      }
    } catch (error) {
      console.error('Google login error:', error);
      showError(`Google login failed: ${error.message}`);
      
      if (onError) {
        onError(error);
      }
    }
  };

  const handleGoogleError = (error) => {
    console.error('Google OAuth error:', error);
    showError('Google login failed. Please try again.');
    
    if (onError) {
      onError(error);
    }
  };

  return (
    <div className={`${styles.googleLoginContainer} ${className}`}>
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        useOneTap
        theme="outline"
        size="large"
        text="continue_with"
        shape="rectangular"
        width="100%"
        className={styles.googleButton}
      />
    </div>
  );
};

export default GoogleLoginButton;
